import React from 'react';
import styles from './LoadingSpinner.module.css';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className={styles.loadingContainer} role="status" aria-live="polite" aria-label="Loading content">
      <div className={styles.spinner} aria-hidden="true">
        <div className={styles.spinnerCircle}></div>
      </div>
      <p className={styles.loadingMessage} aria-hidden="true">{message}</p>
      <span className={styles.srOnly}>Loading content, please wait...</span>
    </div>
  );
};

export default LoadingSpinner;
